import { DeepWritable } from 'ts-essentials';

import { api } from 'app/app.api';

import {
  ReadNotificationApiArg,
  ReadNotificationApiResponse,
  ReadNotificationPreferencesApiResponse,
  ReadNotificationsApiArg,
  ReadNotificationsApiResponse,
  UpdateNotificationPreferencesApiArg,
  UpdateNotificationPreferencesApiResponse,
  UpdateNotificationsAsReadApiArg,
  UpdateNotificationsAsReadApiResponse,
} from './types/notificationsApi.types';
import { transformReadNotifications } from './utils/transformResponse';

export const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readNotifications: builder.query<
      ReadNotificationsApiResponse,
      ReadNotificationsApiArg
    >({
      query: ({ unreadOnly: unread }) => ({
        version: 1,
        path: 'notifications',
        params: { unread },
      }),
      transformResponse: transformReadNotifications,
    }),
    readNotification: builder.query<
      ReadNotificationApiResponse,
      ReadNotificationApiArg
    >({
      query: ({ notificationId }) => ({
        version: 1,
        path: `notifications/${notificationId}`,
      }),
    }),
    updateNotificationsAsRead: builder.query<
      UpdateNotificationsAsReadApiResponse,
      UpdateNotificationsAsReadApiArg
    >({
      query: ({ notificationIds: notification_ids }) => ({
        version: 1,
        method: 'PUT',
        path: 'notifications/read',
        body: {
          notification_ids,
        },
      }),
      async onQueryStarted({ notificationIds }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(
            notificationsApi.util.updateQueryData(
              'readNotifications',
              { unreadOnly: false },
              (draft) => {
                const mutableData = draft.data as DeepWritable<
                  typeof draft.data
                >;
                mutableData.notifications.forEach((notification) => {
                  if (notificationIds.includes(notification.notification_id)) {
                    notification.is_read = true;
                  }
                });
              },
            ),
          );
        } catch (_) {
          // Do nothing
        }
      },
    }),
    readNotificationPreferences: builder.query<
      ReadNotificationPreferencesApiResponse,
      void
    >({
      query: () => ({
        version: 1,
        path: 'notifications/preferences',
      }),
    }),
    updateNotificationPreferences: builder.mutation<
      UpdateNotificationPreferencesApiResponse,
      UpdateNotificationPreferencesApiArg
    >({
      query: ({ email_disabled }) => ({
        version: 1,
        method: 'PUT',
        path: 'notifications/preferences',
        body: {
          email_disabled,
        },
      }),
      async onQueryStarted(data, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(
            notificationsApi.util.updateQueryData(
              'readNotificationPreferences',
              undefined,
              (draft) => {
                const mutableData = draft as DeepWritable<typeof draft>;
                mutableData.data = data;
              },
            ),
          );
        } catch (_) {
          // Do nothing
        }
      },
    }),
  }),
});
